import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function MagnifyingGlassIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon
      viewBox="0 0 24 24"
      {...props}
      style={{
        ...props.style,
        stroke: props.stroke || Color.Body,
        fill: props.fill || Color.White,
        strokeLinecap: props.strokeLinecap || "round",
        strokeLinejoin: props.strokeLinejoin || "round",
        strokeWidth: props.strokeWidth || 2
      }}
    >
      <path d="M15 14.472a6 6 0 1 0-8-8.944 6 6 0 0 0 8 8.944Zm0 0L19.528 19" />
    </MuiSvgIcon>
  );
}
export default MagnifyingGlassIcon;
